module.exports = __webpack_public_path__ + "files/SPIADI2025 - TOP CVP - Fiche Patient Bactériémique.bf67ea6536cd6349b9394de21a7aa13e.pdf";